<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    if (window.performance.navigation.type == 1) {
      console.log("页面被刷新");
      //    console.log(this)
    } else {
      console.log("首次被加载");
    }
  },
  watch: {
    $route(to, from) {
      if (to.path !== "/fgreement") {
        sessionStorage.setItem("sendcode", null);
        console.log(123)
      } else {
        //                 this.$store.dispatch("AsyicOPENSHOW", 1);
      }
    },
  },
};
</script>

<style lang="scss">

img{
  -webkit-user-drag:none
}
.flexs{
    display: flex;
    
}
.zhujue{
  height: 100%;
  display: flex;
  flex-direction: column;
}
.xtable{
  display: flex;
  flex-direction: column;
}
.el-table__body-wrapper{
  flex:1 !important;
}
.el-table__body-wrapper::-webkit-scrollbar-track-piece {
  background-color: #f8f8f8;
}
.el-table__body-wrapper::-webkit-scrollbar {
  width: 13px;
  height: 13px;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #dddddd;
  border-radius: 100px;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}


.xtoubu{
  height:100%;
  display: flex;
  flex-direction: column;
}


.buke{
  cursor:not-allowed;
}
@import url("./utils/css/common.css");
.el-table__empty-block {
  min-height: 60vh !important;
}
.shenflex {
  // height: 66.6vh !important;
}
.xinde .el-table__body-wrapper {
  overflow: auto !important;
  position: relative;
  height: 53vh !important;
}
.xindes .el-table__body-wrapper {
  overflow: auto !important;
  position: relative;
  height: 61vh !important;
}
.xinde .el-table__fixed-right {
  height: 100% !important;
  top: 0;
  left: auto;
  right: 0;
}
el-button {
  display: flex !important;
}
.mb8 .el-button {
  padding: 8px 20px !important;
}
.mb8 .el-col-19 {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
/* 搜索 */
.mb8 .seach {
  display: flex;
  align-items: center;
  border: 1px solid #999999;
  padding: 8px 0;
  height: 40px;
  border-right: 0;
  padding: 8px 0;
  /* height: 40px; */
  height: 32px;
  box-sizing: border-box;
  .el-input {
    border: none;
  }
}
.seach .el-input__inner {
  background-color: transparent !important;
  border: none;
}
/* @import '@/style/reset.css'; */
.el-dialog__footer {
  padding: 10px;
  text-align: center !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.inputse .el-input--suffix .el-input__inner {
  width: 400px !important;
}
.anniu .el-input__inner {
  height: 32px !important;
  width: 200px !important;
}
.con .el-input__inner {
  width: 100%;
}
.fromsBox .el-input__inner {
  width: 100% !important;
  font-size: 16px;
}
.fromsBox .el-form-item__label {
  font-size: 16px;
}
.backoff {
  border-bottom: 3px #e4e7ed solid;
}
.fromsBox {
  margin-top: 80px !important;
}
.shenflex {
  padding-bottom: 5px !important;
}
.infoDetail .el-dialog__headerbtn .el-dialog__close {
  font-size: 20px !important;
  color: #333 !important;
}
.fromsBox .el-input__inner {
  width: 100% !important;
  font-size: 16px;
}

.fromsBox .el-form-item__label {
  font-size: 16px;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
}
.con .el-form-item__content {
  margin-left: 0 !important;
  width: 100%;
}
.anniu {
  height: 32px;
  width: 62px;
  display: flex !important;
  justify-content: center;
  align-items: center;
}
.infoDetail .el-dialog__headerbtn .el-dialog__close {
  font-size: 20px !important;
  color: #fff !important;
}

.infoDetail .el-dialog__header {
  background-color: #005de8 !important;
  height: 45px;
  box-sizing: border-box;
}

.infoDetail .el-dialog__headerbtn {
  top: 12px;
}
.el-tabs--left .el-tabs__item.is-left {
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: end;
  font-size: 18px;
  font-family: MicrosoftYaHei-, MicrosoftYaHei;
  font-weight: normal;
  color: #000000;
}
.infoDetail .el-dialog__body {
  padding: 20px !important;
}
.fromsBox .el-input__inner {
  width: 100% !important;
}
.el-tabs--left .el-tabs__item.is-active {
  background: #1795ff;
  color: #fff;
}
.el-tabs--left {
  height: 100%;
}
.el-tabs__item {
  font-size: 18px;
}
.butti {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}
* {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
img {
  vertical-align: top;
  border: none;
}
* {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
img {
  vertical-align: top;
  border: none;
}
/*清除默认样式*/
html,
body,
div,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p,
dl,
dt,
dd,
ol,
form,
input,
textarea,
th,
td,
select {
  margin: 0;
  padding: 0;
}
* {
  box-sizing: border-box;
}
html,
body {
  min-height: 100%;
}

body {
  font-family: "Microsoft YaHei";
  font-size: 14px;
  color: #333;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
}
ul,
ol {
  list-style: none;
}

img {
  border: none;
  vertical-align: middle;
}

a {
  text-decoration: none;
  color: #232323;
}

table {
  border-collapse: collapse;
  table-layout: fixed;
}

input,
textarea {
  outline: none;
  border: none;
}

textarea {
  resize: none;
  overflow: auto;
}
.shiming {
  height: 500px;
  /* background-color: red; */
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.shiming .el-dialog__header {
  background-color: #1795ff !important;
  height: 45px;
  box-sizing: border-box;
  line-height: 45px;
  padding: 0 10px;
  color: #fff;
}
.shiming .el-dialog__header .el-dialog__title {
  color: #fff;
}

.shiming .el-dialog__headerbtn .el-dialog__close {
  font-size: 20px !important;
  color: #fff !important;
}

.shiming .el-dialog__headerbtn {
  top: 12px;
}

.shiming .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 10px 0 0;
  display: flex;
  flex-direction: column;
}

.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 50%;
}

.tac .el-tabs__content {
  height: 100%;
}
.shous{
    /* 当我们鼠标经过button 按钮的时候，鼠标变成小手，并且去除轮廓线，设置文字颜色 */
    cursor: pointer;
    outline: none;
  
}
.xcontent .el-tabs__content{
  height: 100%;
}
.xcontent .el-tab-pane{
  height: 100%;
  display: flex;
  flex-direction: column;
}
.xcontent .el-table{
  display: flex;
  flex-direction: column;
}
.el-table_2_column_15 .cell{
  display: flex;
    justify-content: center;
}
.el-table--border .el-table__cell:first-child .cell {
    padding-left: 10px;
    display: flex;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/App.vue